import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ribbon from "./components/Ribbon";
import Leistungen from "./components/Leistungen";
import Equipment from "./components/Equipment";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Impressum from "./pages/Impressum";
import Admin from "./pages/Admin";
import { Toaster } from "sonner";

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <Leistungen />
        <Equipment />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App font-body bg-[#F8F9FB] text-[#0A0D1F]">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </LanguageProvider>
    </div>
  );
}

export default App;
